const formatWeight = (value, unit) => {
  if (value == null) return '';
  const safeUnit = unit || 'g';
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return '';
  if (safeUnit === 'g') {
    return numeric >= 1000 ? `${(numeric / 1000).toFixed(2)}kg` : `${numeric}g`;
  }
  if (safeUnit === 'oz') {
    return numeric >= 16 ? `${(numeric / 16).toFixed(2)}lb` : `${numeric}oz`;
  }
  return `${numeric}${safeUnit}`;
};

const formatTimeValue = (value, unitLabel) => {
  if (!value) return '';
  return `${value} ${unitLabel}`;
};

const formatWatering = (value, unit) => {
  if (!value) return '';
  const label = unit === 'weeks' ? 'week(s)' : 'day(s)';
  return `${value} ${label}`;
};

export const createSeedSchema = () => {
  return {
    title: 'Seed Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'name', label: 'Seed Name' },
        {
          key: 'packetWeight',
          label: 'Packet Weight',
          format: (_, row) => formatWeight(row?.packetWeight, row?.weightUnit),
        },
        {
          key: 'seedPrice',
          label: 'Packet Cost',
          format: (val, row) => (row?.priceCurrency ? `${row.priceCurrency}${val}` : val),
        },
      ],
    },
    sections: [
      {
        title: 'Growing Method',
        fields: [
          {
            key: 'soakHours',
            label: 'Soak Hours',
            format: (val) => formatTimeValue(val, 'hour(s)'),
          },
          {
            key: 'germination',
            label: 'Germination Period',
            format: (val) => formatTimeValue(val, 'day(s)'),
          },
          {
            key: 'blackout',
            label: 'Blackout Period',
            format: (val) => formatTimeValue(val, 'day(s)'),
          },
          {
            key: 'wateringFrequency',
            label: 'Water Every',
            format: (val, row) => formatWatering(val, row?.wateringIntervalUnit),
          },
        ],
      },
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};
